import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { saveProducts } from "../../../Store/Modules/Menu/Actions";
import { api } from "../../../Services/Api";
import Answers from "../../../Components/Answers";
import { Context } from "../ProductContext";
import Loading from "../../../Components/Loading";
// import { Container } from './styles';

function AnswersTab() {
  const [saving, setSaving] = useState(false);
  const [answersList, setAnswersList] = useState();
  const { productState, dispatch, saveProduct } = useContext(Context);
  const reduxDispatch = useDispatch();

  function handleChange(answers) {
    //dispatch({ type: "REPLACE_ANSWERS", answers: answers });
    //setSaving(true);
    //getAnswers();
    setAnswersList(answers);
  }

  function handleChangeMany(products) {
    reduxDispatch(saveProducts(products));
  }

  useEffect(() => {
    if (saving) {
      saveProduct();
      setSaving(false);
    }
  }, [productState, saving]);

  function getAnswers() {
    api
      .get(`menu/products/${productState._id}/questions`)
      .then(({ data }) => setAnswersList(data));
  }

  useEffect(() => {
    getAnswers();
  }, []);

  if (!answersList) return <Loading />;

  return (
    <Answers
      product={productState}
      answersList={answersList}
      onChange={handleChange}
      onChangeMany={handleChangeMany}
    />
  );
}

export default AnswersTab;
